import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../../api';

export function useStorageLots() {
  return useQuery(['storageLots'], async () => {
    try {
      const apiResult = await apiGet(`storage/lots?v=${Date.now()}`);
      if (apiResult.ok) {
        return apiResult.json();
      }

      throw new Error('Unable to fetch lots');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      return null;
    }
  });
}

export function useStorageDocuments() {
  return useQuery(['storageDocuments'], async () => {
    try {
      const apiResult = await apiGet(`storage/documents?v=${Date.now()}`);
      if (apiResult.ok) {
        return apiResult.json();
      }

      throw new Error('Unable to fetch documents');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      return null;
    }
  });
}
